<template>
<div :class="[$style.main, 'topologymap-panel']" v-contextmenu:contextmenu v-loading="loading" :style="panelStyle">
  <el-container style="height: 100%;">

    <!-- 툴바 -->
    <el-header :class="[$style.toolbar, 'contents__title']" v-show="this.toolbarVisible" height="84px">
      <h2 :class="[$style.title]">
        <p class="map-title" :title="title">{{title}}</p>
        <w-map-automap-title v-show="isAutomap"></w-map-automap-title>
      </h2>
      <keep-alive>
        <component style="margin-top: -5px;" :is="toolbarComponent"></component>
      </keep-alive>
    </el-header>

    <el-main style="padding: 0;overflow: hidden; height: 100%;">
      <el-container style="height: 100%;">

        <!-- 캔버스 -->
        <el-main style="padding: 0;">
          <el-container style="height: 100%;">
            <el-main style="padding: 0; position: relative;">
              <component :is="canvasComponent"></component>
            </el-main>
            <el-footer height="250px" style="z-index: 1;background-color: #fff;padding: 0px;box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 0 rgba(0, 0, 0, 0.2);" v-if="!isInDashboardWidget" v-show="!isEditMode && isAutomapDeviceTableExpand">
              <w-map-automap-device-table></w-map-automap-device-table>
            </el-footer>
          </el-container>
        </el-main>


        <!-- 타임라인 -->
        <el-aside :width="`${isTimelineExpand ? 335 : 0}px`" style="min-width: auto;z-index: 1;overflow: visible;" v-if="!isInDashboardWidget" v-show="!isEditMode">
          <w-map-timeline></w-map-timeline>
        </el-aside>

      </el-container>
    </el-main>

    <!-- 맵 구성 현황 -->
    <el-footer height="45px" style="z-index: 1;position: relative;padding-left: 30px;background-color: #f7f9fd;border-top: 1px solid #e0e0e0;padding: 0px 0px 0px 20px;" v-if="!isInDashboardWidget" v-show="!isEditMode">
      <w-map-configuration-info></w-map-configuration-info>
      <w-map-tree-visible-button></w-map-tree-visible-button>
    </el-footer>

  </el-container>

  <!-- 트리 편집 모드에 따른 컨텐츠 영역 비활성화 -->
  <div :class="[isTreeEditMode ? $style['disabled-mask'] : '']"></div>

  <!-- 팝업 컨테이너 -->
  <modals-container />

  <!-- 우측 슬라이드 팝업 -->
  <w-map-property-popup ref="mapPropertyPopup" />
  <w-map-download-popup ref="mapDownloadPopup" />
  <w-device-info-popup ref="deviceInfoPopup" />
  <w-image-setting-popup ref="imageSettingPopup" />
  <w-image-select-popup ref="imageSelectPopup" />
  <w-map-label-edit-popup ref="mapLabelEditPopup" />
  <w-device-control-popup ref="deviceControlPopup" />
  <w-admin-access-info-popup ref="adminAccessInfoPopup" />
  <w-object-major-info-popup ref="objectMajorInfoPopup" />
  <w-automap-object-major-info-popup ref="automapObjectMajorInfoPopup" />
  <w-connect-device-info-popup ref="connectDeviceInfoPopup"/>

  <!-- 컨텍스트 메뉴 -->
  <v-contextmenu ref="contextmenu" event-type="none" @show="onContextMenuShow">
    <v-contextmenu-item v-for="item in contextMenuItems" :key="item.id" @click="contextMenuClick" @mouseenter="contextMenuMouseEnter" :item="item" >
      {{ item.label }}
    </v-contextmenu-item>
  </v-contextmenu>
</div>
</template>

<script>
import Vue from 'vue';

import '@/views/topologymap/js/qunee-min';
import '@/views/topologymap/js/svg-icons-object';
import '@/views/topologymap/js/svg-icons-legend';
import '@/views/topologymap/js/svg-icons-etc';
import '@/views/topologymap/js/background';
import '@/views/topologymap/js/flowingSupport';
import '@/views/topologymap/js/eventEffectSupport';
import '@/views/topologymap/js/hierarchicLayouter';
import '@/views/topologymap/js/overview';
import '@/views/topologymap/js/interaction';
import '@/views/topologymap/js/models';
import '@/views/topologymap/js/widget';

import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import MapConst from '@/constants/topologymap';

import Base from '@/mixins/topologymap/base';

import basicinfoSetAPI from '@/api/model/basicinfo-set';

import { Q, MapInfo, MapPopup, MapUtil } from '@/views/topologymap/js/maps';
import WTopologymapCanvas from '@/views/topologymap/layout/TopologymapCanvas';
import WTopologymapMonitoring from '@/views/topologymap/layout/TopologymapMonitoring';
import WTopologymapEdit from '@/views/topologymap/layout/TopologymapEdit';
import WTopologymapSlideShow from '@/views/topologymap/layout/TopologymapSlideShow';
import WMapPropertyPopup from '@/views/topologymap/components/popup/MapPropertyPopup';
import WMapDownloadPopup from '@/views/topologymap/components/popup/MapDownloadPopup';
import WDeviceInfoPopup from '@/views/topologymap/components/popup/DeviceInfoPopup';
import WImageSettingPopup from '@/views/topologymap/components/popup/ImageSettingPopup';
import WImageSelectPopup from '@/views/topologymap/components/popup/ImageSelectPopup';
import WMapLabelEditPopup from '@/views/topologymap/components/popup/MapLabelEditPopup';
import WDeviceControlPopup from '@/views/topologymap/components/popup/DeviceControlPopup';
import WAdminAccessInfoPopup from '@/views/topologymap/components/popup/AdminAccessInfoPopup';
import WObjectMajorInfoPopup from '@/views/topologymap/components/popup/ObjectMajorInfoPopup';
import WAutomapObjectMajorInfoPopup from '@/views/topologymap/components/popup/AutomapObjectMajorInfoPopup';
import WMapTimeline from '@/views/topologymap/components/monitoring/MapTimeline';
import WMapConfigurationInfo from '@/views/topologymap/components/monitoring/MapConfigurationInfo';
import WMapTreeVisibleButton from '@/views/topologymap/components/monitoring/MapTreeVisibleButton';
import WMapAutomapDeviceTable from '@/views/topologymap/components/monitoring/MapAutomapDeviceTable';
import WMapAutomapTitle from '@/views/topologymap/components/monitoring/MapAutomapTitle';
import WConnectDeviceInfoPopup from '@/views/topologymap/components/popup/ConnectDeviceInfoPopup';

Vue.prototype.$mapEventBus = new Vue(); // 토폴로지맵에서 사용할 이벤트버스 등록

export default {
  name: 'WTopologymapPanel',
  components: {
    WTopologymapCanvas,
    WTopologymapMonitoring,
    WTopologymapEdit,
    WTopologymapSlideShow,
    WMapPropertyPopup,
    WMapDownloadPopup,
    WDeviceInfoPopup,
    WImageSettingPopup,
    WImageSelectPopup,
    WMapLabelEditPopup,
    WDeviceControlPopup,
    WAdminAccessInfoPopup,
    WObjectMajorInfoPopup,
    WAutomapObjectMajorInfoPopup,
    WMapTimeline,
    WMapConfigurationInfo,
    WMapTreeVisibleButton,
    WMapAutomapDeviceTable,
    WConnectDeviceInfoPopup,
    WMapAutomapTitle,
  },
  mixins: [Base],
  props: {
    options: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      loading: false,
      loadingText: '',
      toolbarComponent: WTopologymapMonitoring,
      canvasComponent: null,
      toolbarVisible: true,
    };
  },
  created() {
    MapInfo.setInstance(this);
    this.$store.commit('setTopologymapViewMode', MapConst.VIEW_MODE.MONITORING);

    this.$store.commit('setRefreshOptions', this.options);

    // 라우터 파라미터에 툴바를 표현하지 말도록 되어있으면 툴바를 숨긴다.
    if (has(this.options, 'toolbar')) {
      this.showToolbar(this.options.toolbar);
    } else {
      this.showToolbar(!(this.$route.query.toolbar === 'false'));
    }

    document.documentElement.addEventListener('mousemove', this.hideTooltip);

    // 브라우저 새로고침했는데 초기 메뉴가 토폴로지맵이면 store에 customerId가 설정되기 전 시점이므로, 제대로 된 customerId 값을 확인 할 수 없다.
    // 따라서 토폴로지맵은 별도로 customerId를 조회하도록 한다.
    let customerId = 'DEFAULT';
    basicinfoSetAPI.getBasicinfoSet({
      basicinfoId: 'CUSTOMER_ID',
      basicinfoSubid: 'ID',
    }).then((response) => {
      if (response.data.success && !isEmpty(response.data.data)) {
        customerId = response.data.data.basicinfoSubvalueString;
      }
    }).finally(() => {
      if (customerId === 'SKCC' || customerId === 'SKT') {
        Promise.all([
          import('@/views/topologymap/js/svg-icons-sk'),
          import('@/views/topologymap/js/models-sk'),
        ]).finally(() => {
          this.canvasComponent = WTopologymapCanvas;
        });
      } else {
        // 초기화가 완료 된 후에 canvas 컴포넌트를 생성한다.
        this.canvasComponent = WTopologymapCanvas;
      }
    });
  },
  mounted() {
    MapInfo.getInstance(this).setPanel(this);

    this.bindEvent();
  },
  beforeDestroy() {
    // 그래프 Destroy
    const graph = MapInfo.getInstance(this).getGraph();
    if (graph && graph.destroy) {
      graph.destroy();
    }

    // 오브젝트 툴팁 숨기기
    this.hideTooltip();

    try {
      // 컨텍스트 메뉴를 닫고,
      window.$$VContextmenu.undefined.hide();
      // 원 위치로 복귀시킨다.
      document.body.appendChild(window.$$VContextmenu.undefined.$el);
    } catch (e) {
      // ignore
    }

    document.documentElement.removeEventListener('mousemove', this.hideTooltip);
  },
  destroyed() {
    MapInfo.removeInstance(this);
  },
  computed: {
    /**
     * 컨텍스트 메뉴 아이템을 반환한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    contextMenuItems() {
      return this.$store.getters.getContextMenuItems;
    },
    panelStyle() {
      return {
        background: this.isFullScreen ? '#f4f5f6' : 'transparent',
      };
    },
    title() {
      const breadCrumb = this.$store.getters.getBreadcrumb;
      return isEmpty(breadCrumb) ? '' : breadCrumb[breadCrumb.length - 1].mapName;
    },
  },
  watch: {
    /**
     * View 모드가 변경되면 툴바 컴포넌트를 교체한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} mode [description]
     * @return {[type]}      [description]
     */
    viewMode(mode) {
      switch (mode) {
        case MapConst.VIEW_MODE.MONITORING:
          this.toolbarComponent = WTopologymapMonitoring;
          break;
        case MapConst.VIEW_MODE.EDIT:
          this.toolbarComponent = WTopologymapEdit;
          break;
        case MapConst.VIEW_MODE.SLIDESHOW:
          this.toolbarComponent = WTopologymapSlideShow;
          break;
        default:
          this.toolbarComponent = WTopologymapMonitoring;
      }

      this.$nextTick(() => {
        if (mode !== MapConst.VIEW_MODE.TREE_EDIT) { // 트리 편집 모드로 변경 될 경우에는 수행 할 필요가 없다
          MapInfo.getInstance(this).getToolbar(mode).onActivateToolbar();
        }
      });

      // 모든 팝업창 닫기
      MapPopup.closeAndHideAll();
    },
    /**
     * 툴바 표현 상태가 변경되면 그래프 뷰포트를 업데이트한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    toolbarVisible() {
      this.$nextTick(() => {
        const graph = MapInfo.getInstance(this).getGraph();
        if (graph) {
          graph.updateViewport();
        }
      });
    },
  },
  methods: {
    /**
     * 컨텍스트 메뉴가 나타날 때 호출된다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} vm [description]
     * @return {[type]}    [description]
     */
    onContextMenuShow(vm) {
      // 컨텍스트 메뉴가 화면을 벗어나지 않도록 한다.
      this.$nextTick(() => {
        // 컨텍스트 메뉴 DOM은 기본적으로 body 영역에 생성된다.  전체화면시 여러가지 문제점이 있으므로 토폴로지맵 패널 DOM 하위로 위치를 변경한다.
        this.$el.appendChild(vm.$el);

        // 툴바 표현 여부에 따른 위치 조정
        if (this.toolbarVisible) {
          vm.$el.style.top = `${parseInt(vm.$el.style.top, 10) + 40}px`;
        }

        const el = vm.$el;
        const h = el.offsetHeight;
        const w = el.offsetWidth;
        const l = el.offsetLeft;
        const t = el.offsetTop;
        const bh = this.$el.offsetHeight;
        const bw = this.$el.offsetWidth;
        const offset = 5;

        // 오른쪽 영역을 벗어날 경우
        if (l + w > bw) {
          el.style.left = `${(bw - w) - offset}px`;
        }
        // 아래쪽 영역을 벗어날 경우
        if (t + h > bh) {
          el.style.top = `${(bh - h) - offset}px`;
        }
      });
    },
    /**
     * 컨텍스트 메뉴 아이템 클릭
     * 현재 View 모드에 따른 툴바 컴포넌트로 선택한 데이터를 넘긴다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} vm  [description]
     * @param  {[type]} evt [description]
     * @return {[type]}     [description]
     */
    contextMenuClick(vm, evt) {
      const target = this.$store.state.topologymap.contextMenuTarget;

      if (target) {
        const onContextMenuItemSelect = target.onContextMenuItemSelect;
        if (onContextMenuItemSelect && typeof onContextMenuItemSelect === 'function') {
          onContextMenuItemSelect(vm.$attrs.item, evt);
        }
      }
    },
    contextMenuMouseEnter() {
      // 컨텍스트 메뉴 위에 툴팁이 겹치는 경우가 생기므로 컨텍스트 메뉴에 마우스오버하면 툴팁을 강제로 닫는다.
      try {
        Q.TooltipInteraction.prototype.destroy();
      } catch (e) {
        // ignore
      }
    },
    bindEvent() {
      const panel = this.$el;

      // 그래프 영역에 기본 컨텍스트 메뉴를 막는다.
      panel.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        return false;
      });

      // 전체화면 변경 감지해서 툴바 보이기/숨기기 처리
      let fullScreenEvt = '';

      if (panel.msRequestFullscreen) {
        fullScreenEvt = 'MSFullscreenChange';
      } else if (panel.mozRequestFullScreen) {
        fullScreenEvt = 'mozfullscreenchange';
      } else if (panel.webkitRequestFullscreen) {
        fullScreenEvt = 'webkitfullscreenchange';
      } else if (panel.requestFullscreen) {
        fullScreenEvt = 'fullscreenchange';
      }

      const fullScreenFunc = () => {
        let zoomInFunc;

        if (!MapUtil.isFullScreen()) {
          // 풀 스크린이 아니면
          MapInfo.getInstance(this).getPanel().showToolbar(true);
          zoomInFunc = MapInfo.getInstance(this).getCanvas().zoomReset;

          this.$store.commit('setFullScreen', false);
        } else {
          // 풀 스크린이면
          MapInfo.getInstance(this).getPanel().showToolbar(false);
          zoomInFunc = MapInfo.getInstance(this).getCanvas().zoomFit;

          this.$store.commit('setFullScreen', true);
        }
        const graph = MapInfo.getInstance(this).getGraph();
        if (graph) {
          graph.callLater(
            () => {
              if (zoomInFunc) {
                zoomInFunc();
              }
            },
            this,
            300,
          );
        }
        return false;
      };
      panel.removeEventListener(fullScreenEvt, fullScreenFunc);
      panel.addEventListener(fullScreenEvt, fullScreenFunc);
    },
    /**
     * 툴바 표현 상태 변경
     * @author KangBonghun(toto1323)
     * @param  {[type]} visible 표현 여부
     * @return {[type]}         [description]
     */
    showToolbar(visible) {
      this.toolbarVisible = visible;
    },
    /**
     * 맵 새로고침
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    refreshMap() {
      try {
        const canvas = MapInfo.getInstance(this).getCanvas();
        canvas.refreshMap(canvas.getRefreshMapParam().mapId, canvas.getRefreshMapParam().redirect);
      } catch (e) {
        // ignore
      }
    },
    getGraph() {
      return MapInfo.getInstance(this).getGraph();
    },
    /**
     * 위젯 밖 영영으로 마우스가 이동되면 툴팁을 숨긴다..
     * @author KangBonghun(toto1323)
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    hideTooltip(e) {
      // 토폴로지맵 위젯 외부 영역에 마우스 오버하면 getData Function이 없다.
      if (!e || !e.getData) {
        const tooltipEl = document.querySelector('.Q-Tooltip');
        if (tooltipEl) {
          tooltipEl.style.display = 'none';
        }
      }
    },
  },
};
</script>

<style module>
.main {
  width: 100%;
  height: 100%;
}

.canvas {
  width: 100%;
  margin-top: 0px !important;
}

.toolbar {
  background-color: #fff;
  justify-content: flex-end;
  overflow: hidden;
  display: flex;
}

.title {
  flex: 1;
  padding-right: 10px;
  cursor: default;
}

.disabled-mask {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background: #333;
  opacity: 0.7;
  z-index: 1000;
}

</style>
<style lang="scss">
.map-title {
  font-size: 24px;
  color: #333;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/layout/TopologymapPanel.vue